import React, { useEffect, useState, useMemo } from 'react';
import { Layout, Menu, message, Spin } from 'antd';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import { Archives, Mointor, Operation } from '../page/index';
import { useTranslation, Trans } from 'react-i18next';
import { getMenu } from '../API';
import '../i18n/i18n'
import './carLayout.scss'

const { Header, Content, Footer, Sider } = Layout;


const CarLayout = () => {

    const location = useLocation()

    const navigate = useNavigate()

    const [loading, setLoading] = useState(false);

    const [flag, setFlag] = useState(false)
    
    const [language, setLanguage] = useState("")

    const [menuKey, setMenuKey] = useState(() => localStorage.getItem("menuKey") || 'monitor');

    const [menuList, setMenuList] = useState([])

    const { t, i18n } = useTranslation();

    const navList = [
        {
            "车辆监控": t('monitor')
        },
        {
            "车辆档案": t('archives')
        },
        {
            "运营统计": t('operation')
        },
    ]

    const setNav = name => {
        const component = navList.find(c => c[name]);
        return component && component[name];
    }

    
    const keys = [
        {
            "车辆监控": 'monitor'
        },
        {
            "车辆档案": 'archives'
        },
        {
            "运营统计": 'operation'
        },
    ]

    const setKey = name => {
        const component = keys.find(c => c[name]);
        return component && component[name];
    }


    // 使用 useMemo 缓存计算的结果
    const menuItems = useMemo(() => {
        const arr = Array.isArray(menuList) ? menuList.filter(item => item?.parentId === 2) : []
        const list = arr.map((item, index) => ({
            key: setKey(item?.menuName) ?? String(item?.id ?? item?.menuName ?? index),
            icon: <span className={`iconfont icon-nav0${index + 1}`} />,
            label: setNav(item?.menuName) ?? item?.menuName,
        }))
        return list
    }, [menuList, language])

    const getMenuList = () => {
        setLanguage(localStorage.getItem("language"))
        getMenu().then(res => {
            if (res?.data?.code === 200) {
                setMenuList(res.data.data)
            } else if (res?.data?.code === 401) {
                message.error("登录已过期，请重新登陆！")
                navigate("/login")
            } else {
                message.error(res?.data?.msg)
            }
        })
    }

    const menuClick = ({ item, key, keyPath, domEvent }) => {
        localStorage.setItem("menuKey", key)
        setMenuKey(key)
        if (key === "monitor") navigate(`/monitor?${Date.now()}`)
        if (key === "archives") navigate(`/archives?${Date.now()}`)
        if (key === "operation") navigate(`/operation?${Date.now()}`)
    }

    useEffect(() => {
        const name = location.pathname.split('/').filter(Boolean).slice(-1)[0] || 'monitor'
        localStorage.setItem("menuKey", name)
        setMenuKey(name)
    }, [location.pathname])

    useEffect(() => {
        if (!flag) {
            setFlag(true)
        } else {
            getMenuList()
        }
    }, [flag])

    return (
        <Spin spinning={loading} size='large'>
            <Layout>
                <Sider
                    breakpoint="lg"
                    collapsedWidth="0"
                    onBreakpoint={broken => {
                        // console.log(broken);
                    }}
                    onCollapse={(collapsed, type) => {
                        console.log(collapsed, type);
                    }}
                >
                    <div className="demo-logo-vertical">
                        <div className='logoLeft'>
                            <img src={process.env.PUBLIC_URL + '/logo/logo.jpg'} alt='logo' width="54px" height='41px' />
                        </div>
                        <div className='textLogo'>
                            <div className='topText'>
                                {t('platform')}
                            </div>
                        </div>
                    </div>
                    <Menu theme="dark" mode="inline" selectedKeys={[menuKey]} onClick={menuClick} items={menuItems} />
                </Sider>
                <Layout className='main'>
                    <Header style={{ padding: 0, height: "10px", background: "#fff" }} />
                    <Content style={{ margin: '24px 18px 0' }}>
                        <Routes>
                            <Route index element={<Mointor />}></Route>
                            <Route path='/monitor' element={<Mointor setLng={setLanguage} type={"monitor"} />}></Route>
                            <Route path='/archives' element={<Archives setLng={setLanguage} type={"archives"} />}></Route>
                            <Route path='/operation' element={<Operation setLng={setLanguage} type={"operation"} />}></Route>
                        </Routes>
                    </Content>
                </Layout>
            </Layout>
        </Spin>
    )
}

export default CarLayout
